import { render, staticRenderFns } from "./CardIndividualResult.vue?vue&type=template&id=63e0eb76&scoped=true"
import script from "./CardIndividualResult.vue?vue&type=script&lang=js"
export * from "./CardIndividualResult.vue?vue&type=script&lang=js"
import style0 from "./CardIndividualResult.vue?vue&type=style&index=0&id=63e0eb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0eb76",
  null
  
)

export default component.exports